(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pa-collection-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Orden alfabético por defecto en "Ver todos" (/collections/all) si no hay sort elegido
    try {
      var p = window.location.pathname.replace(/\/$/, '');
      var qs = new URLSearchParams(window.location.search);
      if ((p === '/collections/all' || p.endsWith('/collections/all')) && !qs.has('sort_by') && !qs.toString().match(/filter\./)) {
        qs.set('sort_by', 'title-ascending');
        window.location.replace(window.location.pathname + '?' + qs.toString());
      }
    } catch (e) {}

    var toggles = document.querySelectorAll('[data-pa-filter-toggle]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('aria-controls');
        var panel = id ? document.getElementById(id) : null;
        if (!panel) return;
        var open = panel.getAttribute('data-pa-open') === 'true';
        panel.setAttribute('data-pa-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        document.body.style.overflow = open ? '' : 'hidden';
      });
    });
    var inputs = document.querySelectorAll('[data-pa-filter-input]');
    inputs.forEach(function (input) {
      if (input.type === 'checkbox') {
        input.addEventListener('change', function () {
          var form = input.form;
          if (form) form.submit();
        });
      }
    });

    // ---- Filtro por FAMILIA de color (swatches -> filter.p.m.custom.color_list) ----
    document.querySelectorAll('[data-pa-colorfam]').forEach(function (wrap) {
      var form = wrap.closest('form');
      if (!form) return;
      // Marca como activas las familias cuyos colores están en la URL
      try {
        var active = new URLSearchParams(window.location.search).getAll('filter.p.m.custom.color_list').map(function (s) { return s.toLowerCase(); });
        if (active.length) {
          wrap.querySelectorAll('[data-pa-fam]').forEach(function (b) {
            var mem = (b.getAttribute('data-colors') || '').split(',').map(function (c) { return c.trim().toLowerCase(); });
            if (mem.some(function (c) { return active.indexOf(c) !== -1; })) b.classList.add('is-active');
          });
        }
      } catch (e) {}
      wrap.querySelectorAll('[data-pa-fam]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          btn.classList.toggle('is-active');
          // Reúne colores de TODAS las familias activas
          var colors = [];
          wrap.querySelectorAll('[data-pa-fam].is-active').forEach(function (b) {
            (b.getAttribute('data-colors') || '').split(',').forEach(function (c) {
              c = c.trim();
              if (c && colors.indexOf(c) === -1) colors.push(c);
            });
          });
          // Limpia inputs previos de color_list
          form.querySelectorAll('input[name="filter.p.m.custom.color_list"]').forEach(function (i) { i.remove(); });
          // Añade uno por color de las familias activas
          colors.forEach(function (c) {
            var i = document.createElement('input');
            i.type = 'hidden';
            i.name = 'filter.p.m.custom.color_list';
            i.value = c;
            form.appendChild(i);
          });
          // Quita ?page para volver a la primera
          form.querySelectorAll('input[name="page"]').forEach(function (i) { i.remove(); });
          form.submit();
        });
      });
    });

    // Infinite scroll
    var grid = document.querySelector('.pa-coll__grid');
    var loadMore = document.querySelector('[data-pa-loadmore]');
    var spinner = document.querySelector('[data-pa-loadmore-spinner]');
    if (!grid || !loadMore) return;
    var loading = false;
    function fetchNext () {
      if (loading || !loadMore) return;
      loading = true;
      var url = loadMore.getAttribute('href');
      if (spinner) spinner.hidden = false;
      loadMore.style.opacity = '0.4';
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.pa-coll__grid');
          var newLoad = doc.querySelector('[data-pa-loadmore]');
          if (newGrid) {
            Array.prototype.forEach.call(newGrid.children, function (node) {
              grid.appendChild(node.cloneNode(true));
            });
          }
          if (newLoad) {
            loadMore.setAttribute('href', newLoad.getAttribute('href'));
          } else {
            loadMore.remove();
            loadMore = null;
          }
          loading = false;
          if (spinner) spinner.hidden = true;
          if (loadMore) loadMore.style.opacity = '';
        })
        .catch(function () { loading = false; if (spinner) spinner.hidden = true; if (loadMore) loadMore.style.opacity = ''; });
    }
    loadMore.addEventListener('click', function (e) { e.preventDefault(); fetchNext(); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) fetchNext(); });
    }, { rootMargin: '600px 0px' });
    if (loadMore) io.observe(loadMore);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getStep (track) {
      var firstSlide = track.querySelector('.pa-cct__slide, .pa-cct__feature');
      var slideW = firstSlide ? firstSlide.getBoundingClientRect().width : track.clientWidth * 0.9;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 16;
      return slideW + gap;
    }

    function getOriginalGroupWidth (track) {
      var orig = track.querySelector('[data-pa-group]');
      if (!orig || orig.children.length === 0) return 0;
      var first = orig.children[0];
      var last = orig.children[orig.children.length - 1];
      var firstRect = first.getBoundingClientRect();
      var lastRect = last.getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 16;
      return (lastRect.right - firstRect.left) + gap;
    }

    function step (viewport, dir) {
      var track = viewport.querySelector('[data-pa-track]');
      if (!track) return;
      var loop = viewport.hasAttribute('data-pa-loop');
      var s = getStep(track);
      track.scrollBy({ left: dir * s, behavior: 'smooth' });
      if (!loop) return;
      var origW = getOriginalGroupWidth(track);
      if (origW <= 0) return;
      // After the smooth scroll settles, if we've crossed into the cloned
      // group, silently teleport back to the equivalent position in the
      // original group. The user perceives a continuous forward loop.
      window.setTimeout(function () {
        if (track.scrollLeft >= origW) {
          var prev = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = track.scrollLeft - origW;
          // force reflow then restore smooth
          void track.offsetWidth;
          track.style.scrollBehavior = prev || '';
        } else if (track.scrollLeft < 0) {
          var prev2 = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = track.scrollLeft + origW;
          void track.offsetWidth;
          track.style.scrollBehavior = prev2 || '';
        }
      }, 450);
    }

    function initViewport (vp) {
      var track = vp.querySelector('[data-pa-track]');
      if (!track) return;
      var prev = vp.querySelector('[data-pa-prev]');
      var next = vp.querySelector('[data-pa-next]');
      if (prev) prev.addEventListener('click', function () { step(vp, -1); });
      if (next) next.addEventListener('click', function () { step(vp, 1); });

      // ---- Auto-scroll continuo con pausa ----
      if (vp.hasAttribute('data-pa-autoplay')) {
        var speed = parseFloat(vp.getAttribute('data-pa-speed')) || 40; // px/seg
        var paused = false;
        var userStopped = false;
        var lastTs = null;
        var origWcache = 0;
        // El scroll-snap mandatory revierte los incrementos pequeños: lo anulamos
        track.style.scrollSnapType = 'none';

        function tick (ts) {
          if (lastTs == null) lastTs = ts;
          var dt = (ts - lastTs) / 1000;
          lastTs = ts;
          if (!paused && !userStopped && dt > 0 && dt < 0.5) {
            var pbz = track.style.scrollBehavior;
            track.style.scrollBehavior = 'auto';
            track.scrollLeft += speed * dt;
            origWcache = getOriginalGroupWidth(track);
            if (origWcache > 0 && track.scrollLeft >= origWcache) {
              track.scrollLeft -= origWcache;
            }
            track.style.scrollBehavior = pbz || '';
          }
          requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);

        vp.addEventListener('mouseenter', function () { paused = true; });
        vp.addEventListener('mouseleave', function () { paused = false; lastTs = null; });
        vp.addEventListener('touchstart', function () { paused = true; }, { passive: true });
        vp.addEventListener('touchend', function () { setTimeout(function () { if (!userStopped) paused = false; lastTs = null; }, 2500); }, { passive: true });
        vp.addEventListener('focusin', function () { paused = true; });
        vp.addEventListener('focusout', function () { paused = false; lastTs = null; });
        document.addEventListener('visibilitychange', function () { if (document.hidden) paused = true; else { paused = false; lastTs = null; } });

        var ppBtn = vp.querySelector('[data-pa-playpause]');
        if (ppBtn) {
          ppBtn.addEventListener('click', function () {
            userStopped = !userStopped;
            vp.classList.toggle('is-paused', userStopped);
            ppBtn.setAttribute('aria-pressed', userStopped ? 'true' : 'false');
            ppBtn.setAttribute('aria-label', userStopped ? 'Reanudar carrusel' : 'Pausar carrusel');
            if (!userStopped) lastTs = null;
          });
        }
        // prefers-reduced-motion: arranca parado; el botón permite reanudarlo
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          userStopped = true;
          vp.classList.add('is-paused');
          if (ppBtn) {
            ppBtn.setAttribute('aria-pressed', 'true');
            ppBtn.setAttribute('aria-label', 'Reanudar carrusel');
          }
        }
        // Pausar momentáneamente al usar las flechas/arrastrar
        vp.addEventListener('pointerdown', function () { paused = true; });
        vp.addEventListener('pointerup', function () { setTimeout(function () { if (!userStopped) { paused = false; lastTs = null; } }, 2500); });
      }

      // Manual swipe also wraps when reaching the cloned area
      if (vp.hasAttribute('data-pa-loop')) {
        var raf = null;
        track.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            var origW = getOriginalGroupWidth(track);
            if (origW <= 0) return;
            if (track.scrollLeft >= origW) {
              var pb = track.style.scrollBehavior;
              track.style.scrollBehavior = 'auto';
              track.scrollLeft = track.scrollLeft - origW;
              track.style.scrollBehavior = pb || '';
            } else if (track.scrollLeft < 0) {
              var pb2 = track.style.scrollBehavior;
              track.style.scrollBehavior = 'auto';
              track.scrollLeft = track.scrollLeft + origW;
              track.style.scrollBehavior = pb2 || '';
            }
          });
        }, { passive: true });
      }
    }

    document.querySelectorAll('[data-pa-carousel]').forEach(initViewport);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pa-tab]');
      if (!btn) return;
      var target = btn.getAttribute('data-pa-target');
      var id = btn.getAttribute('data-pa-tab');
      document.querySelectorAll('[data-pa-target="' + target + '"]').forEach(function (el) {
        if (el.matches('button[data-pa-tab]')) el.classList.toggle('is-active', el.getAttribute('data-pa-tab') === id);
        if (el.matches('[data-pa-panel]')) el.toggleAttribute('hidden', el.getAttribute('data-pa-panel') !== id);
      });
      // Reset scroll on tab change to start of original group
      var panel = document.querySelector('[data-pa-panel="' + id + '"][data-pa-target="' + target + '"]');
      if (panel) {
        var t = panel.querySelector('[data-pa-track]');
        if (t) {
          var pb = t.style.scrollBehavior;
          t.style.scrollBehavior = 'auto';
          t.scrollLeft = 0;
          t.style.scrollBehavior = pb || '';
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bars = document.querySelectorAll('[data-pa-countdown]');
    if (!bars.length) return;
    function tick(bar) {
      var target = new Date(bar.getAttribute('data-pa-countdown'));
      var ms = Math.max(0, target.getTime() - Date.now());
      var d = Math.floor(ms / 86400000);
      var h = Math.floor((ms / 3600000) % 24);
      var m = Math.floor((ms / 60000) % 60);
      var s = Math.floor((ms / 1000) % 60);
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var dEl = bar.querySelector('[data-pa-cd-days]');
      var hEl = bar.querySelector('[data-pa-cd-hours]');
      var mEl = bar.querySelector('[data-pa-cd-mins]');
      var sEl = bar.querySelector('[data-pa-cd-secs]');
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    bars.forEach(function (bar) { tick(bar); setInterval(function () { tick(bar); }, 1000); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // En móvil los acordeones del pie empiezan cerrados: el HTML los trae abiertos para que en
    // escritorio se vean como columnas, y en móvil eso alargaba el pie varias pantallas.
    // Si la ventana pasa a tamaño escritorio, se vuelven a abrir.
    const mq = window.matchMedia('(max-width: 767px)');
    // Un acordeón con el aviso de la newsletter (éxito o error tras enviar) se queda abierto.
    const apply = () => document.querySelectorAll('.pa-footer__details').forEach((d) => {
      d.open = !mq.matches || !!d.querySelector('.pa-footer__newsletter-success, .pa-footer__newsletter-error');
    });
    if (mq.matches) apply();
    mq.addEventListener('change', apply);

    // "Preferencias de cookies": el banner de Shopify (window.privacyBanner) carga asíncrono;
    // el botón solo aparece cuando existe, para no mostrar nunca un botón que no hace nada.
    let tries = 0;
    const enableCookiePrefs = () => {
      const banner = window.privacyBanner;
      if (!banner || typeof banner.showPreferences !== 'function') {
        if (++tries < 20) setTimeout(enableCookiePrefs, 500);
        return;
      }
      document.querySelectorAll('[data-cookie-prefs]').forEach((el) => {
        el.hidden = false;
        if (el.tagName === 'BUTTON') el.addEventListener('click', () => banner.showPreferences());
      });
    };
    enableCookiePrefs();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-gift-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pa-gc]');
    if (!root) return;
    var form = root.querySelector('[data-gc-form]');
    var idInput = root.querySelector('[data-gc-id]');
    var cardAmount = root.querySelector('[data-gc-card-amount]');
    var addPrice = root.querySelector('[data-gc-add-price]');
    var addBtn = root.querySelector('[data-gc-add]');
    var addLabel = root.querySelector('[data-gc-add-label]');
    var err = root.querySelector('[data-gc-err]');
    var giftToggle = root.querySelector('[data-gc-gift-toggle]');
    var giftFields = root.querySelector('[data-gc-gift-fields]');
    var sendFlag = root.querySelector('[data-gc-send-flag]');
    var rEmail = root.querySelector('[data-gc-remail]');
    var busy = false;

    // Amount selection
    root.querySelectorAll('[data-gc-amount]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-gc-amount]').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-checked', 'true');
        idInput.value = b.getAttribute('data-id');
        if (cardAmount) cardAmount.textContent = b.getAttribute('data-title');
        if (addPrice) addPrice.textContent = b.getAttribute('data-price');
      });
    });

    // Gift toggle: enable/disable recipient fields
    function setGift(on) {
      if (giftFields) giftFields.hidden = !on;
      root.querySelectorAll('[data-gc-gift-fields] input, [data-gc-gift-fields] textarea').forEach(function (el) {
        if (el === sendFlag) { el.disabled = !on; el.value = on ? '1' : ''; }
        else { el.disabled = !on; }
      });
      if (err) err.hidden = true;
    }
    if (giftToggle) giftToggle.addEventListener('change', function () { setGift(giftToggle.checked); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      // validate recipient email if gifting
      if (giftToggle && giftToggle.checked && (!rEmail || !rEmail.value.trim())) {
        if (err) err.hidden = false;
        if (rEmail) rEmail.focus();
        return;
      }
      busy = true;
      var prevTxt = addLabel ? addLabel.textContent : '';
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Añadiendo…';

      // build properties from enabled property inputs
      var props = {};
      root.querySelectorAll('[name^="properties["]').forEach(function (el) {
        if (el.disabled) return;
        var m = el.name.match(/^properties\[(.+)\]$/);
        if (m && String(el.value).trim()) props[m[1]] = el.value;
      });
      var item = { id: idInput.value, quantity: 1 };
      if (Object.keys(props).length) item.properties = props;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
      .then(function (r) { if (!r.ok) { return r.json().then(function (j) { throw j; }); } return r.json(); })
      .then(function () { return fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); }); })
      .then(function (html) {
        var d = document.getElementById('cart-drawer');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-root]');
        var c = d && d.querySelector('[data-cart-drawer-content]');
        if (fresh && c) { c.innerHTML = ''; c.appendChild(fresh); }
        if (d) { try { d.showModal(); } catch (er) { d.setAttribute('open', ''); } }
        busy = false; if (addBtn) addBtn.disabled = false; if (addLabel) addLabel.textContent = prevTxt || 'Añadir al carrito';
      })
      .catch(function () {
        busy = false; if (addBtn) addBtn.disabled = false; if (addLabel) addLabel.textContent = prevTxt || 'Añadir al carrito';
        window.location.href = '/cart';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pa-header]').forEach(function (h) {
      h.addEventListener('mouseenter', function () { h.classList.add('is-hovered'); });
      h.addEventListener('mouseleave', function () { h.classList.remove('is-hovered'); });
    });

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pa-menu-toggle]');
      if (t) {
        var drawer = document.querySelector('[data-pa-drawer]');
        if (drawer) drawer.toggleAttribute('hidden');
        return;
      }

      // Mega menu toggle (mainly for keyboard / touch — desktop hover handled in CSS)
      var megaToggle = e.target.closest('[data-pa-mega-toggle]');
      if (megaToggle) {
        var item = megaToggle.closest('[data-pa-mega]');
        if (item) {
          var isOpen = item.classList.contains('is-open');
          document.querySelectorAll('[data-pa-mega].is-open').forEach(function (el) {
            if (el !== item) el.classList.remove('is-open');
          });
          // On touch, prevent default link follow on first tap; allow on second.
          if (window.matchMedia('(hover: none)').matches && !isOpen) {
            e.preventDefault();
            item.classList.add('is-open');
            megaToggle.setAttribute('aria-expanded', 'true');
            return;
          }
          if (isOpen) {
            megaToggle.setAttribute('aria-expanded', 'false');
            item.classList.remove('is-open');
          }
        }
      } else if (!e.target.closest('[data-pa-mega]')) {
        document.querySelectorAll('[data-pa-mega].is-open').forEach(function (el) {
          el.classList.remove('is-open');
          var btn = el.querySelector('[data-pa-mega-toggle]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      }

      var pop = e.target.closest('[data-pa-popout]');
      if (e.target.closest('[data-pa-popout-toggle]')) {
        document.querySelectorAll('[data-pa-popout]').forEach(function (el) {
          if (el !== pop) el.classList.remove('is-open');
        });
        if (pop) pop.classList.toggle('is-open');
        return;
      }
      if (!pop) {
        document.querySelectorAll('[data-pa-popout]').forEach(function (el) { el.classList.remove('is-open'); });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-pa-mega].is-open').forEach(function (el) {
          el.classList.remove('is-open');
          var btn = el.querySelector('[data-pa-mega-toggle]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-pa-pdp]');
    sections.forEach(function (section) {
      initGallery(section);
      initQuantity(section);
      initVariants(section);
      initMobileBar(section);
      initRecommendations(section);
      initPersonalization(section);
    });

    function initGallery(root) {
      var slides = root.querySelectorAll('[data-pa-gallery-slide]');
      var thumbs = root.querySelectorAll('[data-pa-gallery-thumb]');
      if (!slides.length) return;

      function activate(index) {
        slides.forEach(function (slide) {
          var match = String(slide.dataset.index) === String(index);
          slide.classList.toggle('is-active', match);
          slide.setAttribute('aria-pressed', match ? 'true' : 'false');
        });
        thumbs.forEach(function (thumb) {
          var match = String(thumb.dataset.index) === String(index);
          thumb.classList.toggle('is-active', match);
          thumb.setAttribute('aria-pressed', match ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activate(thumb.dataset.index);
        });
      });

      slides.forEach(function (slide) {
        slide.addEventListener('click', function () {
          var idx = parseInt(slide.dataset.index, 10) || 0;
          var next = (idx + 1) % slides.length;
          activate(next);
        });
      });
    }

    function initQuantity(root) {
      var input = root.querySelector('[data-pa-qty-input]');
      if (!input) return;
      var dec = root.querySelector('[data-pa-qty-dec]');
      var inc = root.querySelector('[data-pa-qty-inc]');
      if (dec) dec.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (inc) inc.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    }

    function initVariants(root) {
      var dataScript = root.querySelector('[data-pa-variants]');
      if (!dataScript) return;
      var variants;
      try { variants = JSON.parse(dataScript.textContent); } catch (e) { return; }
      if (!variants || !variants.length) return;

      var hiddenId = root.querySelector('[data-pa-variant-id]');
      var optionInputs = root.querySelectorAll('[data-pa-option-input]');
      var priceCurrent = root.querySelector('[data-pa-price-current]');
      var priceCompare = root.querySelector('[data-pa-price-compare]');
      var pricePrefix = root.querySelector('.pa-pdp__price-prefix');
      var mobilePrice = root.querySelector('[data-pa-mobile-price]');
      var availabilityText = root.querySelector('[data-pa-availability-text]');
      var availabilityDot = root.querySelector('.pa-pdp__dot');
      var ctaLabel = root.querySelector('[data-pa-cta-label]');
      var ctaButton = root.querySelector('[data-pa-add-to-cart]');
      var mobileCtaLabel = root.querySelector('[data-pa-mobile-cta-label]');
      var mobileCtaButton = root.querySelector('[data-pa-mobile-add]');
      var inStockLabel = (availabilityText && availabilityText.textContent.trim()) || 'En stock';
      var soldOutLabel = (ctaButton && ctaButton.dataset.soldOutLabel) || 'Agotado';
      var addLabel = (ctaButton && ctaLabel && ctaLabel.textContent.trim()) || 'Añadir al carrito';
      var soldOutText = root.dataset.soldOutText || 'Agotado';

      function getOptionFieldsets() {
        return Array.prototype.slice.call(root.querySelectorAll('[data-pa-option-index]'));
      }

      function selectedValues() {
        return getOptionFieldsets().map(function (fs) {
          var input = fs.querySelector('[data-pa-option-input]:checked');
          return input ? input.value : null;
        });
      }

      function findVariant(values) {
        return variants.find(function (v) {
          return v.options.every(function (opt, idx) {
            return values[idx] == null ? true : opt === values[idx];
          });
        });
      }

      // Formato de moneda real de la tienda (shop.money_format, p. ej. amount_with_comma_separator + " €").
      // Antes caía en toFixed(2) + ' €' y la ficha pintaba "28.00 €" en lugar de "28,00 €".
      function formatMoney(cents) {
        var value = (Number(cents) || 0) / 100;
        var group = function (decimals, thousands, decimal) {
          var p = value.toFixed(decimals).split('.');
          var ints = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return decimals ? ints + decimal + p[1] : ints;
        };
        var fmt = root.getAttribute('data-money-format') || '{' + '{amount_with_comma_separator}} €';
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
          switch (key) {
            case 'amount': return group(2, ',', '.');
            case 'amount_no_decimals': return group(0, ',', '.');
            case 'amount_no_decimals_with_comma_separator': return group(0, '.', ',');
            case 'amount_with_apostrophe_separator': return group(2, "'", '.');
            case 'amount_with_space_separator': return group(2, ' ', ',');
            default: return group(2, '.', ',');
          }
        });
      }

      function updateSwatchHighlight() {
        getOptionFieldsets().forEach(function (fs) {
          var selectedInput = fs.querySelector('[data-pa-option-input]:checked');
          fs.querySelectorAll('.pa-pdp-swatch, .pa-pdp-chip').forEach(function (lbl) {
            var inp = lbl.querySelector('[data-pa-option-input]');
            lbl.classList.toggle('is-active', !!(inp && inp.checked));
          });
          var selectedLabel = fs.querySelector('[data-pa-option-selected]');
          if (selectedLabel && selectedInput) selectedLabel.textContent = selectedInput.value;
        });
      }

      function updateAvailabilityHints() {
        var values = selectedValues();
        getOptionFieldsets().forEach(function (fs, fsIdx) {
          fs.querySelectorAll('[data-pa-option-input]').forEach(function (inp) {
            var trial = values.slice();
            trial[fsIdx] = inp.value;
            var matched = variants.find(function (v) {
              return v.options.every(function (opt, idx) {
                return trial[idx] == null ? true : opt === trial[idx];
              });
            });
            var label = inp.closest('.pa-pdp-swatch, .pa-pdp-chip');
            if (label) label.classList.toggle('is-unavailable', !(matched && matched.available));
          });
        });
      }

      function update() {
        var values = selectedValues();
        var variant = findVariant(values);
        updateSwatchHighlight();
        updateAvailabilityHints();

        if (!variant) {
          if (ctaButton) { ctaButton.disabled = true; if (ctaLabel) ctaLabel.textContent = soldOutText; }
          if (mobileCtaButton) { mobileCtaButton.disabled = true; if (mobileCtaLabel) mobileCtaLabel.textContent = soldOutText; }
          if (availabilityText) availabilityText.textContent = soldOutText;
          if (availabilityDot) { availabilityDot.classList.remove('pa-pdp__dot--ok'); availabilityDot.classList.add('pa-pdp__dot--out'); }
          return;
        }

        if (hiddenId) hiddenId.value = variant.id;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        if (priceCurrent) {
          priceCurrent.textContent = formatMoney(variant.price);
          priceCurrent.classList.toggle('pa-pdp__price-current--sale', !!(variant.compare_at_price && variant.compare_at_price > variant.price));
        }
        if (mobilePrice) mobilePrice.textContent = formatMoney(variant.price);
        if (priceCompare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceCompare.textContent = formatMoney(variant.compare_at_price);
            priceCompare.removeAttribute('hidden');
          } else {
            priceCompare.setAttribute('hidden', '');
            priceCompare.textContent = '';
          }
        }
        if (pricePrefix) pricePrefix.style.display = 'none';

        if (availabilityText) availabilityText.textContent = variant.available ? inStockLabel : soldOutText;
        if (availabilityDot) {
          availabilityDot.classList.toggle('pa-pdp__dot--ok', variant.available);
          availabilityDot.classList.toggle('pa-pdp__dot--out', !variant.available);
        }
        if (ctaButton) {
          ctaButton.disabled = !variant.available;
          if (ctaLabel) ctaLabel.textContent = variant.available ? addLabel : soldOutText;
        }
        if (mobileCtaButton) {
          mobileCtaButton.disabled = !variant.available;
          if (mobileCtaLabel) mobileCtaLabel.textContent = variant.available ? addLabel : soldOutText;
        }

        if (variant.featured_media && variant.featured_media.position) {
          var idx = variant.featured_media.position - 1;
          root.querySelectorAll('[data-pa-gallery-slide]').forEach(function (slide) {
            slide.classList.toggle('is-active', String(slide.dataset.index) === String(idx));
          });
          root.querySelectorAll('[data-pa-gallery-thumb]').forEach(function (thumb) {
            thumb.classList.toggle('is-active', String(thumb.dataset.index) === String(idx));
          });
        }
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', update);
      });

      root.querySelectorAll('[data-pa-option-index]').forEach(function (fs) {
        fs.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var inputs = Array.prototype.slice.call(fs.querySelectorAll('[data-pa-option-input]'));
          var checkedIdx = inputs.findIndex(function (i) { return i.checked; });
          if (checkedIdx === -1) return;
          var nextIdx = e.key === 'ArrowRight' ? (checkedIdx + 1) % inputs.length : (checkedIdx - 1 + inputs.length) % inputs.length;
          inputs[nextIdx].checked = true;
          inputs[nextIdx].focus();
          update();
          e.preventDefault();
        });
      });

      if (mobileCtaButton) {
        mobileCtaButton.addEventListener('click', function () {
          var form = root.querySelector('#pa-pdp-form');
          if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }

      update();
    }

    function initMobileBar(root) {
      var bar = root.querySelector('[data-pa-mobile-bar]');
      var anchor = root.querySelector('[data-pa-add-to-cart]');
      if (!bar || !anchor) return;
      // Solo cuando el botón principal ya ha quedado ARRIBA: en móvil queda debajo de la
      // galería al cargar y la barra salía desde el principio, tapando las miniaturas.
      // Scroll + rAF en vez de IntersectionObserver: al saltar de golpe arriba (volver arriba,
      // anclas) el botón no cruza la pantalla, el observer no avisa y la barra se quedaba.
      var pending = false;
      function syncBar() {
        pending = false;
        var visible = anchor.getBoundingClientRect().bottom < 0;
        if (visible === bar.classList.contains('is-visible')) return;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }
      window.addEventListener('scroll', function () {
        if (!pending) {
          pending = true;
          requestAnimationFrame(syncBar);
        }
      }, { passive: true });
      syncBar();
    }

    function initPersonalization(root) {
      var box = root.querySelector('[data-pa-perso]');
      if (!box) return;
      var check = box.querySelector('[data-pa-perso-check]');
      var panel = box.querySelector('[data-pa-perso-panel]');
      var text = box.querySelector('[data-pa-perso-text]');
      var persoVariant = box.getAttribute('data-perso-variant');
      var form = root.querySelector('#pa-pdp-form');
      if (!check || !form || !persoVariant) return;

      // El textarea no envía propiedad si no está marcado
      text.disabled = true;
      check.addEventListener('change', function () {
        panel.hidden = !check.checked;
        text.disabled = !check.checked;
        if (check.checked) { setTimeout(function () { text.focus(); }, 50); }
      });

      var busy = false;
      function doPersonalizedAdd(e) {
        if (!check.checked) return;            // sin personalizar -> flujo normal
        // Detener TODO (navegación nativa + handler global del cart-drawer)
        if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
        if (busy) return;
        if (!text.value.trim()) {
          panel.hidden = false; text.disabled = false; text.focus();
          text.setAttribute('placeholder', 'Por favor, dinos qué quieres personalizar');
          return;
        }
        busy = true;
        var fd = new FormData(form);
        var mainId = fd.get('id');
        var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
        var props = {};
        fd.forEach(function (val, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m && String(val).trim()) props[m[1]] = val;
        });
        var items = [
          { id: mainId, quantity: qty, properties: props },
          { id: persoVariant, quantity: qty, properties: { 'Para': (document.title.split('·')[0] || '').trim(), 'Detalle': text.value.trim() } }
        ];
        var btn = form.querySelector('[data-pa-add-to-cart]');
        var lbl = btn && btn.querySelector('[data-pa-cta-label]');
        var prevTxt = lbl ? lbl.textContent : '';
        if (btn) btn.disabled = true;
        if (lbl) lbl.textContent = 'Añadiendo…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); }); })
        .then(function (html) {
          var d = document.getElementById('cart-drawer');
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer-root]');
          var c = d && d.querySelector('[data-cart-drawer-content]');
          if (fresh && c) { c.innerHTML = ''; c.appendChild(fresh); }
          if (d) { try { d.showModal(); } catch (err) { d.setAttribute('open', ''); } }
          busy = false;
          if (btn) btn.disabled = false;
          if (lbl) lbl.textContent = prevTxt || 'Añadir al carrito';
        })
        .catch(function () {
          busy = false;
          if (btn) btn.disabled = false;
          if (lbl) lbl.textContent = prevTxt || 'Añadir al carrito';
          window.location.href = '/cart';
        });
      }

      // Triple intercept (capture phase = corre antes que cualquier otro handler)
      var addBtn = form.querySelector('[data-pa-add-to-cart]');
      if (addBtn) addBtn.addEventListener('click', doPersonalizedAdd, true);
      form.addEventListener('submit', doPersonalizedAdd, true);
      document.addEventListener('submit', function (e) {
        if (e.target === form) doPersonalizedAdd(e);
      }, true);
    }

    function initRecommendations(root) {
      var wrap = root.querySelector('[data-pa-recommendations]');
      if (!wrap) return;
      var productId = root.dataset.productId;
      if (!productId) return;
      var sectionId = root.closest('[id^="shopify-section-"]');
      if (!sectionId) return;
      var url = '/recommendations/products?section_id=' + sectionId.id.replace('shopify-section-', '') + '&product_id=' + productId + '&limit=4&intent=related';
      fetch(url).then(function (res) { return res.text(); }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-pa-recommendations]');
        if (fresh) wrap.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-shop-by"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pa-shopby]');
    if (!root) return;
    var cta = root.querySelector('[data-pa-shopby-cta]');
    // Base con el idioma/mercado actual (routes.all_products_collection_url en el href inicial)
    var baseUrl = cta ? cta.getAttribute('href').split('?')[0] : '/collections/all';
    var ctaLabel = root.querySelector('[data-pa-shopby-cta-label]');
    var clearBtn = root.querySelector('[data-pa-shopby-clear]');

    function buildUrl () {
      var params = [];
      var count = 0;
      root.querySelectorAll('[data-pa-filter="color"].is-active').forEach(function (b) {
        var members = (b.getAttribute('data-members') || b.getAttribute('data-pa-value') || '').split(',');
        members.forEach(function (m) {
          m = m.trim();
          if (m) params.push('filter.p.m.custom.color_list=' + encodeURIComponent(m));
        });
        count++;
      });
      root.querySelectorAll('[data-pa-filter="tag"].is-active').forEach(function (b) {
        params.push('filter.p.tag=' + encodeURIComponent(b.getAttribute('data-pa-value')));
        count++;
      });
      root.querySelectorAll('[data-pa-filter="tamano"].is-active').forEach(function (b) {
        params.push('filter.p.m.custom.tamano=' + encodeURIComponent(b.getAttribute('data-pa-value')));
        count++;
      });
      root.querySelectorAll('[data-pa-filter="cierre"].is-active').forEach(function (b) {
        (b.getAttribute('data-members') || '').split(',').forEach(function (m) {
          m = m.trim();
          if (m) params.push('filter.p.m.custom.cierre_list=' + encodeURIComponent(m));
        });
        count++;
      });
      var priceBtn = root.querySelector('[data-pa-filter="price"].is-active');
      if (priceBtn) {
        var min = priceBtn.getAttribute('data-pa-min') || '';
        var max = priceBtn.getAttribute('data-pa-max') || '';
        if (min) params.push('filter.v.price.gte=' + min);
        if (max) params.push('filter.v.price.lte=' + max);
        count++;
      }
      var qs = params.length ? '?' + params.join('&') : '';
      return { url: baseUrl + qs, count: count };
    }

    function refresh () {
      var b = buildUrl();
      cta.setAttribute('href', b.url);
      if (b.count === 0) {
        ctaLabel.textContent = 'Ver pendientes';
        clearBtn.hidden = true;
      } else {
        ctaLabel.textContent = 'Ver pendientes (' + b.count + ')';
        clearBtn.hidden = false;
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pa-filter]');
      if (btn) {
        var kind = btn.getAttribute('data-pa-filter');
        if (kind === 'price') {
          // Radio behavior — only one price active
          var was = btn.classList.contains('is-active');
          root.querySelectorAll('[data-pa-filter="price"]').forEach(function (b2) { b2.classList.remove('is-active'); });
          if (!was) btn.classList.add('is-active');
        } else {
          btn.classList.toggle('is-active');
        }
        refresh();
        return;
      }
      if (e.target.closest('[data-pa-shopby-clear]')) {
        root.querySelectorAll('.is-active').forEach(function (b2) { b2.classList.remove('is-active'); });
        refresh();
      }
    });

    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'gc_wishlist_v1';
    var root = document.querySelector('[data-wish-grid]');
    if (!root) return;
    var sec = root.closest('.pa-wish');
    var emptyEl = sec.querySelector('[data-wish-empty]');
    var loadEl = sec.querySelector('[data-wish-loading]');
    var countEl = sec.querySelector('[data-wish-count-text]');

    function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function write(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }
    function money(c) { return (Number(c || 0) / 100).toFixed(2).replace('.', ',') + ' €'; }

    function show(el) { if (el) el.hidden = false; }
    function hide(el) { if (el) el.hidden = true; }

    function render() {
      var ids = read();
      hide(loadEl);
      if (!ids.length) {
        hide(root); show(emptyEl);
        if (countEl) countEl.textContent = '';
        return;
      }
      hide(emptyEl); show(loadEl); hide(root);
      if (countEl) countEl.textContent = ids.length + (ids.length === 1 ? ' producto guardado' : ' productos guardados');

      Promise.all(ids.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (prods) {
        hide(loadEl);
        var valid = prods.filter(Boolean);
        if (!valid.length) { hide(root); show(emptyEl); return; }
        root.innerHTML = valid.map(function (p) {
          var cmp = (p.compare_at_price && p.compare_at_price > p.price) ? p.compare_at_price : 0;
          var img = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=700') : '';
          var needsPick = p.variants && p.variants.length > 1;
          var vId = p.variants && p.variants[0] ? p.variants[0].id : p.id;
          return ''
            + '<article class="pa-wish__card" data-h="' + p.handle + '">'
            +   '<div class="pa-wish__card-media">'
            +     '<button type="button" class="pa-wish__remove" data-wish-remove="' + p.handle + '" aria-label="Quitar de favoritos">'
            +       '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
            +     '</button>'
            +     '<a href="' + p.url + '">' + (img ? '<img loading="lazy" src="' + img + '" alt="' + (p.title || '').replace(/"/g, '') + '">' : '') + '</a>'
            +   '</div>'
            +   '<div class="pa-wish__card-body">'
            +     '<a href="' + p.url + '" class="pa-wish__card-title">' + p.title + '</a>'
            +     '<p class="pa-wish__card-price">'
            +       (cmp ? '<span class="pa-wish__price-cur">' + money(p.price) + '</span><span class="pa-wish__price-cmp">' + money(cmp) + '</span>' : '<span>' + money(p.price) + '</span>')
            +     '</p>'
            +     (needsPick
                  ? '<a href="' + p.url + '" class="pa-wish__add" style="display:flex;align-items:center;justify-content:center;text-decoration:none;">Elegir opciones</a>'
                  : '<button type="button" class="pa-wish__add" data-wish-add="' + vId + '">Añadir al carrito</button>')
            +   '</div>'
            + '</article>';
        }).join('');
        show(root);
      });
    }

    document.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-wish-remove]');
      if (rm) {
        var h = rm.getAttribute('data-wish-remove');
        var arr = read().filter(function (x) { return x !== h; });
        write(arr);
        document.dispatchEvent(new CustomEvent('gc:wishlist-change'));
        render();
        return;
      }
      var add = e.target.closest('[data-wish-add]');
      if (add) {
        var id = add.getAttribute('data-wish-add');
        add.disabled = true; add.textContent = 'Añadiendo…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        }).then(function () {
          add.textContent = 'Añadido';
          var d = document.getElementById('cart-drawer');
          if (d && typeof d.showModal === 'function') {
            fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('[data-cart-drawer-root]');
              var c = d.querySelector('[data-cart-drawer-content]');
              if (fresh && c) { c.innerHTML = ''; c.appendChild(fresh); }
              try { d.showModal(); } catch (e) {}
            });
          }
          setTimeout(function () { add.disabled = false; add.textContent = 'Añadir al carrito'; }, 1500);
        }).catch(function () { add.disabled = false; add.textContent = 'Añadir al carrito'; });
      }
    });

    render();
    window.addEventListener('pageshow', render);
  })();

  } catch(e) { console.error(e); }
})();
})();
